import { render, staticRenderFns } from "./DeptSelect.vue?vue&type=template&id=6bd61c18&scoped=true&"
import script from "./DeptSelect.vue?vue&type=script&lang=js&"
export * from "./DeptSelect.vue?vue&type=script&lang=js&"
import style0 from "./DeptSelect.vue?vue&type=style&index=0&id=6bd61c18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd61c18",
  null
  
)

export default component.exports